import { MaskLineOnView } from "./ContactHeadline";
import { Reveal } from "./anim";

export default function PageIntro({ overline, title, subtitle }) {
  return (
    <section className="relative bg-base pt-36 md:pt-44 pb-8 md:pb-12 px-6 md:px-10">
      <div className="mx-auto max-w-[1600px]">
        <Reveal as="p" className="font-mono text-xs uppercase tracking-[0.25em] text-accent mb-6">
          {overline}
        </Reveal>
        <h1 className="font-heading font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl lg:text-[6.5rem]">
          <MaskLineOnView>{title}</MaskLineOnView>
        </h1>
        {subtitle && (
          <Reveal delay={0.15} as="p" className="mt-8 max-w-2xl text-[#A1A1AA] text-lg md:text-xl leading-relaxed">
            {subtitle}
          </Reveal>
        )}
      </div>
    </section>
  );
}
